import { GetPersonUser } from '@esportal/portal-service';
import { Container, ContainerGutter, NotificationBar, Text } from '@volkswagen-onehub/components-core';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import * as React from 'react';
import { MastersContext } from './context/masters-context';
// import { ApuntateFormLayer } from './form/apuntate-form-layer';
import { DrivingExperience } from './sections/driving-experience';
import { EscuelaGallery } from './sections/escuela-gallery';
import { Footer } from './sections/footer';
import { GeneralWrapper } from './sections/general-wrapper';
import { Header } from './sections/header';
import { Intro } from './sections/intro';
import { MastersInfo } from './sections/masters-info';
import { Parallax } from './sections/parallax';
import Video from './sections/video';

gsap.registerPlugin(ScrollToPlugin);

export function Home(): JSX.Element {
	const { pageInfoService, breacrumbService, portalService } = React.useContext(MastersContext);

	const [userData, setUserData] = React.useState<GetPersonUser | null>(null);
	const [isNotificationBarVisible, setIsNotificationBarVisible] = React.useState(true);

	// const apuntateLayerRef = React.useRef<HTMLDivElement | null>(null);
	// const [isApuntateLayerOpen, setIsApuntateLayerOpen] = React.useState<boolean>(false);

	//const promotion = userData?.portalUser.data.clubVW.promotions?.find((p) => p.name === 'MastersCarretera2026');

	React.useEffect(() => {
		breacrumbService.set([]);
		pageInfoService.setPageInfo();
	}, [pageInfoService, breacrumbService]);

	React.useEffect(() => {
		const subscription = portalService.getPerson().subscribe({
			next: (data: GetPersonUser | null) => {
				setUserData(data);
			},
		});
		return () => subscription.unsubscribe();
	}, [portalService]);

	// React.useEffect(() => {
	// 	if (
	// 		userData?.portalUser.data.climapro.status == UserStatus.OK ||
	// 		userData?.portalUser.data.climapro.status == UserStatus.PREMATCH
	// 	) {
	// 		const subscription = portalService.getPersonVehicles().subscribe({
	// 			next: (data: DataVehicles | null) => {
	// 				setUserVehicles(data);
	// 			},
	// 		});
	// 		return () => subscription.unsubscribe();
	// 	}
	// 	return undefined;
	// }, [portalService, userData]);

	// React.useEffect(() => {
	// 	const subscription = portalService.hasToLog().subscribe(setHasToLog);
	// 	return () => subscription.unsubscribe();
	// }, [portalService]);

	React.useEffect(() => {
		if (!window.location?.pathname) return;

		const splittedPath = window.location.pathname.split('/');
		const hasApuntate = splittedPath.some((path) => path.replace('.app', '') === 'apuntate');

		if (hasApuntate) {
			setTimeout(() => {
				handleScrollTo('apuntate-section');
			}, 500);
		}
	}, []);

	const isAnimatingRef = { current: false };

	const handleScrollTo = (targetId: string) => {
		const element =
			document.getElementById(targetId) ||
			(document.querySelector(`[data-testid="${targetId}"]`) as HTMLElement | null);

		if (!element || isAnimatingRef.current) return;

		isAnimatingRef.current = true;

		const isIOSSafari = /iPad|iPhone|iPod/.test(navigator.userAgent);
		const offset = 60;

		const y = element.getBoundingClientRect().top + window.pageYOffset - offset;

		if (isIOSSafari) {
			window.scrollTo({
				top: y,
				behavior: 'smooth',
			});

			setTimeout(() => {
				isAnimatingRef.current = false;
			}, 700);
		} else {
			try {
				const scrollContainer = document.scrollingElement || document.documentElement;

				gsap.killTweensOf(scrollContainer);

				gsap.to(scrollContainer, {
					scrollTo: {
						y,
						autoKill: false,
					},
					duration: 0.6,
					ease: 'power1.out',
					onComplete: () => {
						isAnimatingRef.current = false;
					},
					onInterrupt: () => {
						isAnimatingRef.current = false;
					},
				});
			} catch {
				window.scrollTo({
					top: y,
					behavior: 'smooth',
				});

				setTimeout(() => {
					isAnimatingRef.current = false;
				}, 700);
			}
		}
	};

	return (
		<>
			{isNotificationBarVisible && (
				<NotificationBar
					data-testid="notification-bar"
					onClose={() => setIsNotificationBarVisible(false)}
					closeButtonLabel="Close notification bar"
				>
					<Container verticalAlign="center" gutter={ContainerGutter.static200} shrinkContent>
						<Text>
							<b>Las inscripciones ya están cerradas.</b> ¡Pronto anunciaremos a las personas seleccionadas!
						</Text>
					</Container>
				</NotificationBar>
			)}
			<GeneralWrapper>
				{/* {promotion && (
					<ApuntateFormLayer
						promotion={promotion}
						isApuntateLayerOpen={isApuntateLayerOpen}
						setIsApuntateLayerOpen={setIsApuntateLayerOpen}
						apuntateLayerRef={apuntateLayerRef}
					/>
				)} */}

				<Header />
				{/* <MastersButton onApuntateClick={() => handleScrollTo('apuntate-section')} /> */}
				<Intro />
				<Video />
				<MastersInfo />
				{/* <Apuntate
					promotion={promotion}
					userData={userData}
					userVehicles={userVehicles}
					hasToLog={hasToLog}
					setIsApuntateLayerOpen={setIsApuntateLayerOpen}
				/> */}
				<EscuelaGallery />
				<Parallax />
				<DrivingExperience />
				<Footer userData={userData} />
			</GeneralWrapper>
		</>
	);
}
